import { useId } from "react";

export function Crest({ size = 34 }) {
  const id = useId().replace(/:/g, "");
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden="true" className="shrink-0" shapeRendering="geometricPrecision">
      <defs>
        <linearGradient id={`g${id}`} x1="8" y1="6" x2="30" y2="36" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#E2CC97" /><stop offset="1" stopColor="#B39457" /></linearGradient>
        <mask id={`m${id}`}><rect width="40" height="40" fill="#fff" /><circle cx="24.3" cy="15.8" r="14.6" fill="#000" /></mask>
      </defs>
      <circle cx="20" cy="20" r="15" fill={`url(#g${id})`} mask={`url(#m${id})`} />
      <path d="M26 9.4 C26.41 12.3 27.7 13.59 30.6 14 C27.7 14.41 26.41 15.7 26 18.6 C25.59 15.7 24.3 14.41 21.4 14 C24.3 13.59 25.59 12.3 26 9.4 Z" fill="#F5F2E9" />
    </svg>
  );
}

export function Wordmark({ light = false, testid }) {
  const main = light ? "text-[#172A3A]" : "text-[#F5F2E9]";
  return (
    <span className="flex items-center gap-3" data-testid={testid}>
      <Crest size={32} />
      <span className="flex flex-col leading-none">
        <span className={`font-academic ${main} text-[17px] sm:text-[19px] font-semibold tracking-tight`}>Infant Sleep Consultant Near Me</span>
        <span className="mt-1 text-[#BDA677] text-[9px] sm:text-[10px] font-semibold tracking-[0.16em] sm:tracking-[0.2em] uppercase whitespace-nowrap">Expert Sleep Guidance for Parents</span>
      </span>
    </span>
  );
}
